export default {
  all_alerts: { method: "get", url: "api/alerts" },
  unread_count: { method: "get", url: "api/alerts/unread-count" },
  mark_read: { method: "put", url: "api/alerts/mark-as-read" },
};
